import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Information} from '../../../model/information';
import {FormGroup} from "@angular/forms";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

import {InformationFormGeneratorService} from "../../../formulaires/admin/information-form-generator.service";
import {DynamicModalFormComponent} from "../../../components/common/dynamic-modal-form/dynamic-modal-form.component";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-create-information-action',
    templateUrl: './create-information-action.component.html',
    imports: [
    DynamicModalFormComponent,
    FaIconComponent
],
    styleUrls: ['./create-information-action.component.css']
})
export class CreateInformationActionComponent {

  @Input() info: Information;
  @Output()
  onSave = new EventEmitter<Information>();

  actions = [{
    label: 'Sauvegarder en brouillon',
    class: 'btn-outline-primary',
    icon: 'save',
    action: (form: FormGroup, modal: NgbModalRef) => {
      this.info.draft = true;
      modal.close();
    }
  }, {
    condition: () => !this.info.draft,
    label: 'Publier',
    class: 'btn-primary',
    icon: 'plus'
  }];

  constructor(public informationFormGeneratorService: InformationFormGeneratorService) {
  }

  createNewInfo(): void {
    this.info = new Information();
  }

  beforeSave($event: any): void {
    if (this.info.draft && !$event.draft) {
      $event.publication = new Date();
    } else {
      $event.publication = this.info.publication || new Date();
    }
    $event.draft = this.info.draft;
    this.onSave.emit($event);
  }
}
